/**
 * Category Archive Page Sidebar
 *
 * Detect change in category filter.
 */

export default function() {

  if ($('.category-archive__sb').length === 0)
    return;

  $('.category-archive__go-to-category').change(function() {
    window.location = $(this).val();
  });
}
